import React from "react";
import "../Css_files/blog.css";
import img1 from "../Images/mechanical engineer.png";
import img2 from "../Images/electrical engineer.png";
import img3 from "../Images/civil engineer .png";
import img4 from "../Images/ECE.png";
import img5 from "../Images/IT .png";
import img6 from "../Images/CSE.png";
import { Link } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";

function Blog() {
  return (
    <div className="blog-container">
      <Navbar />
      <div className="blog-heading-box" style={{ marginTop: "100px" }}>
        <h1 className="blog-heading-title">Blog</h1>
      </div>

      <div className="blog-grid-container">
        <Link to="/blog2" className="blog-image-box">
          <img src={img1} alt="Mechanical Engineering" />
          <p className="blog-sub-caption">
            In 2025, mechanical engineers must master tools like SolidWorks, AutoCAD, ANSYS, and MATLAB. These software help in design, simulation, and automation.
          </p>
        </Link>

        <Link to="/blog3" className="blog-image-box">
          <img src={img2} alt="Electrical Engineering" />
          <p className="blog-sub-caption">
            Electrical engineers should focus on embedded systems, IoT, and power electronics. Simulation tools and programming languages are vital.
          </p>
        </Link>

        <Link to="/blog4" className="blog-image-box">
          <img src={img3} alt="Civil Engineering" />
          <p className="blog-sub-caption">
            AutoCAD is best for 2D drafting; Revit is great for 3D modeling and BIM. Civil engineers choose based on project needs.
          </p>
        </Link>

        <Link to="/blog5" className="blog-image-box">
          <img src={img4} alt="ECE" />
          <p className="blog-sub-caption">
            ECE engineers should learn Cadence, Synopsys, and Mentor Graphics. These are crucial for chip design and verification.
          </p>
        </Link>

        <Link to="/blog6" className="blog-image-box">
          <img src={img5} alt="IT" />
          <p className="blog-sub-caption">
            IT students must know front-end and back-end tech, with tools like Git, REST APIs, and cloud deployment.
          </p>
        </Link>

        <Link to="/blog7" className="blog-image-box">
          <img src={img6} alt="CSE" />
          <p className="blog-sub-caption">
            CSE students should master version control, debugging, and scalable coding. GitHub and Docker are essential tools.
          </p>
        </Link>
      </div>

      <Footer />
    </div>
  );
}

export default Blog;
